<template>
  <div>
    <v-progress-linear
      indeterminate
      color="primary darken-2"
      v-if="loading"
    ></v-progress-linear>
    <LiveDetail v-if="getEventsLiveDetail.length > 0"></LiveDetail>

    <v-card
      class="tournament-card-preview"
      elevation="1"
      v-if="
        !checkIsMobile() &&
        !checkIsTablet() &&
        getEventsLiveDetail.length == 0 &&
        getCountLive.length > 0
      "
    >
      <div class="tournament-card-header header-live">
        <div class="">
          <span class="label-live">{{ $t('live') }}</span>
        </div>
        <div class="" @click="changeLiveMode('detail')">
          <span class="action-btn" :title="$t('allLiveEvents')"
            >{{ $t('allLiveEvents') }}
            <v-icon dense>mdi-chevron-right</v-icon></span
          >
        </div>
      </div>
      <div class="sport-live-content">
        <v-slide-group show-arrows class="pt-2 pb-2" active-class="success">
          <v-slide-item
            v-for="(item, index) in this.getCountLive"
            :key="$uuid.v1()"
          >
            <v-btn
              small
              class="mx-2"
              depressed
              rounded
              @click="changeLive(item.sport)"
              :class="item.selected ? 'active-sport' : ''"
            >
              <span class="text-sport text-capitalize">{{
                getTitle(item.sport)
              }}</span>
              <!--                <span class="count">{{ item.count }}</span> -->
            </v-btn>
          </v-slide-item>
        </v-slide-group>
        <v-progress-linear
          indeterminate
          color="primary darken-2"
          v-if="this.getLoadingLive"
        ></v-progress-linear>
        <div class="preview" v-if="!this.getLoadingLive">
          <v-card
            class="tournament-card-preview"
            elevation="1"
            style="margin-top: 10px"
          >
            <div
              class="tournament-single"
              v-for="(object, index) in this.getPreviewLive"
              v-if="checkIfEvents(object.events) && index < limit"
            >
              <div class="header">
                <div class="path">
                  <img
                    :src="categoryPath + object.category.id + '.svg'"
                    :alt="object.category.name"
                  />
                  <span class="category-text" :title="object.category.name">{{
                    object.category.name
                  }}</span>
                  <span
                    class="tournament-text highlight"
                    :title="object.tournament.name"
                  >
                    <v-icon dense x-small>mdi-chevron-right</v-icon>
                    {{ object.tournament.name }}
                  </span>
                </div>
                <template v-if="markets_size < 3">
                  <div
                    class="markets-void"
                    v-for="z in 3 - markets_size"
                    :key="$uuid.v1()"
                  >
                    <span class="name">&nbsp;</span>
                  </div>
                </template>

                <div
                  class="markets"
                  v-for="(mrkt, idx) in object.markets"
                  :key="$uuid.v1()"
                  v-if="idx < 3"
                >
                  <div
                    class="outcome"
                    v-if="mrkt.outcomes.length == 2 && mrkt.specifiers != ''"
                  ></div>
                  <div
                    class="outcome"
                    :class="[
                      mrkt.outcomes.length == 2 && mrkt.specifiers == ''
                        ? 'outcome-50'
                        : '',
                    ]"
                    v-for="(outcome, j) in mrkt.outcomes"
                    :key="$uuid.v1()"
                  >
                    <span class="name">{{ outcome.name }}</span>
                  </div>
                </div>
                <div class="other-odds"></div>
              </div>
              <div class="matches-list">
                <div
                  class="event"
                  v-for="(event, index) in object.events"
                  :key="$uuid.v1()"
                  :class="index % 2 == 0 ? 'even' : 'odd'"
                >
                  <div
                    class="info-match"
                    @click="
                      getDetailOfEventLive(
                        event.id,
                        event.type,
                        object.sport.id,
                        object.tournament.id ? object.tournament.id : '',
                        event.status
                      )
                    "
                  >
                    <span class="competitors">
                      <span class="home" :title="event.competitors.home.name">
                        {{ event.competitors.home.name }}
                        <template
                          v-if="
                            sportIdsPlayerServer.includes(object.sport.id) &&
                            isServing(event.livescore, 'home')
                          "
                        >
                          <v-badge dot inline left color="#ffec00"></v-badge>
                        </template>
                      </span>
                      <span class="away" :title="event.competitors.away.name">
                        {{ event.competitors.away.name }}
                        <template
                          v-if="
                            sportIdsPlayerServer.includes(object.sport.id) &&
                            isServing(event.livescore, 'away')
                          "
                        >
                          <v-badge dot inline left color="#ffec00"></v-badge>
                        </template>
                      </span>
                    </span>
                    <span class="live-info">
                      <span class="label-live-text">{{ $t('live') }}</span>
                      <span class="current-per">{{
                        getMatchCurrentPeriod(
                          event.livescore.Scoreboard.CurrentPeriod
                        )
                      }}</span>
                      <span
                        v-if="
                          getUserType == 4 ||
                          getCashier ||
                          !getSettings.enableQuickBetOnlyForAgency
                        "
                        class="event-qbet"
                        title="qbet"
                      >
                        {{ event.quickbet }}
                      </span>
                      <!--                        <span class="time" v-if="event.livescore.Scoreboard.Time != '-1'">{{getMatchCurrentTime(event.livescore.Scoreboard.Time)}} <span class="blink_me">'</span></span>-->
                    </span>
                  </div>
                  <div class="info-match-result">
                    <span
                      class="time"
                      v-if="event.livescore.Scoreboard.Time != '-1'"
                    >
                      <v-icon x-small>mdi-timer</v-icon
                      >{{
                        getMatchCurrentTime(event.livescore.Scoreboard.Time)
                      }}
                      <span class="blink_me">'</span>
                    </span>
                    <span class="result">
                      {{
                        getResult(event.livescore.Scoreboard.Results, 'home')
                      }}
                      <span class="blink_me"> : </span>
                      {{
                        getResult(event.livescore.Scoreboard.Results, 'away')
                      }}
                    </span>
                  </div>
                  <template v-if="markets_size < 3">
                    <div
                      class="markets-void"
                      v-for="z in 3 - markets_size"
                      :key="$uuid.v1()"
                    >
                      <div class="odds group-sign" v-for="n in 3"></div>
                    </div>
                  </template>
                  <div
                    class="odds group-sign"
                    v-for="(oddMarket, idz) in event.odds"
                    :key="$uuid.v1()"
                    v-if="idz < 3"
                  >
                    <div
                      v-if="
                        oddMarket.odds.length == 2 && oddMarket.specifiers != ''
                      "
                      class="odd"
                    >
                      <span class="specifier">{{ oddMarket.specifiers }}</span>
                    </div>
                    <div
                      v-if="!oddMarket.void"
                      class="odd"
                      v-for="(odd, index) in oddMarket.odds"
                      :key="$uuid.v1()"
                      :class="[
                        oddMarket.odds.length == 2 && oddMarket.specifiers == ''
                          ? 'outcome-50'
                          : '',
                      ]"
                    >
                      <v-icon
                        class="arrow-up"
                        v-if="
                          odd.type_change == 'up' &&
                          odd.outcome_odd_value > 0 &&
                          odd.active
                        "
                      >
                        mdi-arrow-up
                      </v-icon>
                      <v-icon
                        class="arrow-down"
                        v-if="
                          odd.type_change == 'down' &&
                          odd.outcome_odd_value > 0 &&
                          odd.active
                        "
                      >
                        mdi-arrow-down
                      </v-icon>
                      <div
                        v-if="odd.outcome_odd_value > 0 && odd.active"
                        class="value"
                        :class="[
                          'multi-' + oddMarket.multiplicity_min,
                          odd.type_change != undefined
                            ? 'odd_value_' + odd.type_change
                            : 'odd_value_equal',
                          getOddsSources.includes(odd.unique_id)
                            ? 'odd_selected'
                            : '',
                        ]"
                        @click="
                          putCart(
                            odd,
                            event,
                            object.sport,
                            object.category,
                            object.tournament
                          )
                        "
                      >
                        <div
                          :class="[
                            odd.type_change != undefined
                              ? odd.type_change
                              : 'equal',
                          ]"
                        ></div>
                        {{ odd.outcome_odd_value | odds_type_filter }}
                      </div>
                      <div
                        v-else
                        class="value"
                        :class="'multi-' + oddMarket.multiplicity_min"
                      >
                        <v-icon dense>mdi-lock</v-icon>
                      </div>
                    </div>

                    <div
                      v-if="oddMarket.void"
                      class="odd"
                      v-for="n in oddMarket.n_outcomes"
                      :key="$uuid.v1()"
                    >
                      <div
                        class="value locked"
                        :class="'multi-' + oddMarket.multiplicity_min"
                      >
                        <v-icon dense>mdi-lock</v-icon>
                      </div>
                    </div>
                  </div>
                  <div class="odds group-sign other-odds">
                    <div class="odd">
                      <div
                        v-if="event.count_odds > 0"
                        class="value"
                        @click="
                          getDetailOfEventLive(
                            event.id,
                            event.type,
                            object.sport.id,
                            object.tournament.id ? object.tournament.id : '',
                            event.status
                          )
                        "
                        v-bind:class="{
                          'detail-opened': getEventsLiveDetailActive.includes(
                            event.id
                          ),
                        }"
                        :class="
                          getOddsType == 'american' ? 'btn-more-american' : ''
                        "
                      >
                        <span v-if="getOddsType == 'decimal'"
                          >+ {{ event.count_odds }}</span
                        >
                        <span v-if="getOddsType == 'american'">{{
                          $t('moreBets')
                        }}</span>
                      </div>
                      <div v-else class="value locked">
                        <v-icon dense>mdi-lock</v-icon>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-card>
          <div class="text-center pb-2" @click="changeLiveMode('detail')">
            <span class="action-btn show-others" :title="$t('allLiveEvents')"
              >{{ $t('allLiveEvents') }}
              <v-icon dense>mdi-chevron-right</v-icon></span
            >
          </div>
        </div>
        <div v-else class="preview">
          <v-skeleton-loader
            v-bind="attrs"
            type="date-picker"
          ></v-skeleton-loader>
        </div>
      </div>
    </v-card>
    <v-card
      class="tournament-card-preview"
      elevation="1"
      v-if="
        (checkIsMobile() || checkIsTablet()) &&
        getEventsLiveDetail.length == 0 &&
        getCountLive.length > 0
      "
    >
      <template v-if="this.getCountLive.length > 0">
        <div class="tournament-card-header header-live">
          <div class="">
            <span class="label-live">{{ $t('live') }}</span>
          </div>
          <div class="" @click="changeLiveMode('detail')">
            <span class="action-btn" :title="$t('allLiveEvents')"
              >{{ $t('allLiveEvents') }}
              <v-icon dense>mdi-chevron-right</v-icon></span
            >
          </div>
        </div>
        <div class="sport-live-content sport-live-content-mobile">
          <v-slide-group
            show-arrows
            class="pt-2 pb-2"
            active-class="success"
            v-if="this.checkIsMobile() || this.checkIsTablet()"
          >
            <v-slide-item
              v-for="(item, index) in this.getCountLive"
              :key="$uuid.v1()"
            >
              <v-btn
                small
                class="mx-2"
                depressed
                rounded
                @click="changeLive(item.sport)"
                :class="item.selected ? 'active-sport' : ''"
              >
                <span class="text-sport text-capitalize">{{
                  getTitle(item.sport)
                }}</span>
                <!--                <span class="count">{{ item.count }}</span> -->
              </v-btn>
            </v-slide-item>
          </v-slide-group>
          <v-progress-linear
            indeterminate
            color="primary darken-2"
            v-if="this.getLoadingLive"
          ></v-progress-linear>
          <div class="preview" v-if="!this.getLoadingLive">
            <v-card class="tournament-card-preview" elevation="1">
              <div class="tournament-card-header">
                <div class="actions"></div>
                <div class="markets-select">
                  <v-select
                    v-model="market_selected"
                    :items="this.markets"
                    outlined
                    item-text="name"
                    item-value="unique_id"
                    dense
                  >
                    <template v-slot:append>
                      <v-icon>mdi-unfold-more-horizontal</v-icon>
                    </template>
                  </v-select>
                </div>
                <!--              <div class="other-odds"></div>-->
              </div>
              <div
                class="tournament-single"
                v-for="(object, index) in this.getPreviewLive"
                v-if="checkIfEvents(object.events) && index < limit"
              >
                <div class="header">
                  <div class="path">
                    <img
                      :src="categoryPath + object.category.id + '.svg'"
                      :alt="object.category.name"
                    />
                    <!--                  <span class="category-text" :title="object.category.name">{{ object.category.name }}</span>-->
                    <span
                      class="tournament-text highlight"
                      :title="object.tournament.name"
                    >
                      <v-icon dense x-small>mdi-chevron-right</v-icon>
                      {{ object.tournament.name | truncate(28, '..') }}
                    </span>
                  </div>

                  <div
                    class="markets"
                    v-for="(mrkt, idx) in object.markets"
                    :key="$uuid.v1()"
                    v-if="idx == 0 && market_selected == mrkt.id"
                  >
                    <div
                      class="outcome"
                      v-if="mrkt.outcomes.length == 2 && mrkt.specifiers != ''"
                    ></div>
                    <div
                      class="outcome"
                      :class="[
                        mrkt.outcomes.length == 2 && mrkt.specifiers == ''
                          ? 'outcome-50'
                          : '',
                      ]"
                      v-for="(outcome, j) in mrkt.outcomes"
                      :key="$uuid.v1()"
                    >
                      <span class="name">{{ outcome.name }}</span>
                    </div>
                  </div>
                  <!--                <div class="other-odds"></div>-->
                </div>

                <div class="matches-list">
                  <div
                    class="event"
                    v-for="(event, index) in object.events"
                    :key="$uuid.v1()"
                    :class="index % 2 == 0 ? 'even' : 'odd'"
                    v-if="event.livescore.Scoreboard.Status == 2"
                  >
                    <div
                      class="info-match"
                      @click="
                        getDetailOfEventLive(
                          event.id,
                          event.type,
                          object.sport.id,
                          object.tournament.id ? object.tournament.id : '',
                          event.status
                        )
                      "
                    >
                      <span class="competitors">
                        <span class="home" :title="event.competitors.home.name">
                          {{ event.competitors.home.name | truncate(20, '..') }}
                          <template
                            v-if="
                              sportIdsPlayerServer.includes(object.sport.id) &&
                              isServing(event.livescore, 'home')
                            "
                          >
                            <v-badge dot inline left color="#ffec00"></v-badge>
                          </template>
                        </span>
                        <span class="away" :title="event.competitors.away.name">
                          {{ event.competitors.away.name | truncate(20, '..') }}
                          <template
                            v-if="
                              sportIdsPlayerServer.includes(object.sport.id) &&
                              isServing(event.livescore, 'away')
                            "
                          >
                            <v-badge dot inline left color="#ffec00"></v-badge>
                          </template>
                        </span>
                      </span>
                      <span class="live-info">
                        <span class="label-live-text">{{ $t('live') }}</span>
                        <span
                          class="time"
                          v-if="event.livescore.Scoreboard.Time != '-1'"
                        >
                          {{
                            getMatchCurrentTime(event.livescore.Scoreboard.Time)
                          }}
                          <span class="blink_me">'</span>
                        </span>
                        <span class="current-per">{{
                          getMatchCurrentPeriod(
                            event.livescore.Scoreboard.CurrentPeriod
                          )
                        }}</span>
                      </span>
                    </div>

                    <div class="info-match-result">
                      <!--                    <span class="time" v-if="event.livescore.Scoreboard.Time != '-1'">-->
                      <!--                      <v-icon x-small>mdi-timer</v-icon>{{getMatchCurrentTime(event.livescore.Scoreboard.Time)}} <span class="blink_me">'</span>-->
                      <!--                    </span>-->
                      <span class="result">
                        {{
                          getResult(event.livescore.Scoreboard.Results, 'home')
                        }}
                        <br />
                        <!--                      <span class="blink_me"> : </span>-->
                        {{
                          getResult(event.livescore.Scoreboard.Results, 'away')
                        }}
                      </span>
                    </div>
                    <!--                  <template v-if="markets_size < 3">-->
                    <!--                    <div class="markets-void" v-for="z in 3-markets_size" :key="z">-->
                    <!--                      <div class="odds group-sign" v-for="n in 3"></div>-->
                    <!--                    </div>-->
                    <!--                  </template>-->
                    <div class="odds-box">
                      <div
                        class="odds group-sign"
                        v-for="(oddMarket, idz) in event.odds"
                        :key="$uuid.v1()"
                        v-if="oddMarket.unique_id == market_selected"
                      >
                        <div
                          v-if="
                            oddMarket.odds.length == 2 &&
                            oddMarket.specifiers != ''
                          "
                          class="odd"
                        >
                          <span class="specifier">{{
                            oddMarket.specifiers
                          }}</span>
                        </div>
                        <div
                          v-if="!oddMarket.void"
                          class="odd"
                          v-for="(odd, index) in oddMarket.odds"
                          :key="$uuid.v1()"
                          :class="[
                            oddMarket.odds.length == 2 &&
                            oddMarket.specifiers == ''
                              ? 'outcome-50'
                              : '',
                          ]"
                        >
                          <!--                        <v-icon class="arrow-up"-->
                          <!--                                v-if="odd.type_change == 'up' && odd.outcome_odd_value > 0  && odd.active">mdi-arrow-up-->
                          <!--                        </v-icon>-->
                          <!--                        <v-icon class="arrow-down"-->
                          <!--                                v-if="odd.type_change == 'down' && odd.outcome_odd_value > 0  && odd.active">-->
                          <!--                          mdi-arrow-down-->
                          <!--                        </v-icon>-->
                          <div
                            v-if="odd.outcome_odd_value > 0 && odd.active"
                            class="value"
                            :class="[
                              'multi-' + oddMarket.multiplicity_min,
                              odd.type_change != undefined
                                ? 'odd_value_' + odd.type_change
                                : 'odd_value_equal',
                              getOddsSources.includes(odd.unique_id)
                                ? 'odd_selected'
                                : '',
                            ]"
                            @click="
                              putCart(
                                odd,
                                event,
                                object.sport,
                                object.category,
                                object.tournament
                              )
                            "
                          >
                            <div
                              :class="[
                                odd.type_change != undefined
                                  ? odd.type_change
                                  : 'equal',
                              ]"
                            ></div>
                            {{ odd.outcome_odd_value | odds_type_filter }}
                          </div>
                          <div
                            v-else
                            class="value"
                            :class="'multi-' + oddMarket.multiplicity_min"
                          >
                            <v-icon dense>mdi-lock</v-icon>
                          </div>
                        </div>

                        <div
                          v-if="oddMarket.void"
                          class="odd"
                          v-for="n in oddMarket.n_outcomes"
                          :key="$uuid.v1()"
                        >
                          <div
                            class="value locked"
                            :class="'multi-' + oddMarket.multiplicity_min"
                          >
                            <v-icon dense>mdi-lock</v-icon>
                          </div>
                        </div>
                      </div>
                      <div class="other-odds" v-if="event.count_odds > 0">
                        <div
                          class="label-other-odds"
                          @click="
                            getDetailOfEventLive(
                              event.id,
                              event.type,
                              object.sport.id,
                              object.tournament.id ? object.tournament.id : '',
                              event.status
                            )
                          "
                          v-bind:class="{
                            'detail-opened': getEventsLiveDetailActive.includes(
                              event.id
                            ),
                          }"
                          :class="
                            getOddsType == 'american' ? 'btn-more-american' : ''
                          "
                        >
                          {{ $t('showOther') }}
                          <span v-if="getOddsType == 'decimal'"
                            >+ {{ event.count_odds }}</span
                          >
                          <span v-if="getOddsType == 'american'">{{
                            $t('moreBets')
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-card>
            <div class="text-center pb-2" @click="changeLiveMode('detail')">
              <span class="action-btn show-others" :title="$t('allLiveEvents')"
                >{{ $t('allLiveEvents') }}
                <v-icon dense>mdi-chevron-right</v-icon></span
              >
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="this.getLoadingLive === false">
        <div class="d-flex-center-all pt-3 pb-3">
          <v-icon large>mdi-access-point-off</v-icon>
        </div>
        <div class="d-flex-center-all pt-3 pb-3">
          <span class="d-flex-center-all">{{
            $t('noLiveEvents') | capitalize
          }}</span>
        </div>
      </template>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
// import _ from 'lodash'
import LiveDetail from '@/components/center_widgets/LiveDetail'
import { isMobileOnly, isTablet } from 'mobile-device-detect'
import {
  checkIsMobileDevice,
  checkIsTabletDevice,
} from '../../plugins/device-inspector'

export default {
  name: 'LiveHomeWidget',
  data: () => ({
    isMobileOnly: isMobileOnly,
    isTablet: isTablet,
    sportIdsPlayerServer: [3467550448],
    limit: 4,
    offset: 3,
    livesCount: [],
    loading: false,
    categoryPath:
      process.env.VUE_APP_URL_CLOUDFRONT +
      '/svg/categories/rectangular_flags_category/',
    // sportPath: process.env.VUE_APP_URL_CLOUDFRONT + '/sport-images/icons/',
    // sportPath: process.env.VUE_APP_URL_CLOUDFRONT + '/svg/sports/light/',
    sportPath: process.env.VUE_APP_URL_CLOUDFRONT + '/svg/sports/icons/',
    light: window.icons == 'light' ? true : false,
    markets: [],
    market_selected: '',
    markets_size: 0,
    markets_size2: 0,
    all_categories: [],
    categories_filtered: [],
    attrs: {
      class: 'mb-6',
      boilerplate: true,
      elevation: 2,
    },
  }),
  components: { LiveDetail },
  computed: {
    ...mapGetters({
      getLanguage: 'settings/getLanguage',
      getFilter: 'tree/getFilter',
      getPreviewLive: 'odds/getPreviewLive',
      getCountLive: 'odds/getCountLive',
      getEventsLiveDetailActive: 'odds/getEventsLiveDetailActive',
      getLoadingPreview: 'odds/getLoadingPreview',
      getLoadingLive: 'odds/getLoadingLive',
      getOddsSources: 'cart/getOddsSources',
      getRulesManager: 'rules/getRulesManager',
      getRulesSkin: 'rules/getRulesSkin',
      getPlatformId: 'settings/getPlatformId',
      getEventsLiveDetail: 'odds/getEventsLiveDetail',
      getUserType: 'user/getType',
      getCashier: 'user/getCashier',
      getSettings: 'cart/getSettings',
      getOddsType: 'odds/getOddsType',
    }),
  },
  methods: {
    ...mapActions({
      setFilter: 'tree/setFilter',
      removeFromPreview: 'odds/removeFromPreview',
      fetchEventDetail: 'odds/fetchEventDetail',
      fetchEventLiveDetail: 'odds/fetchEventLiveDetail',
      setLoadingPreview: 'odds/setLoadingPreview',
      setLoadingLive: 'odds/setLoadingLive',
      addOddToCart: 'cart/addOddToCart',
      fetchLive: 'odds/fetchLive',
      setLiveMode: 'odds/setLiveMode',
      setLiveSportSelected: 'odds/setLiveSportSelected',
    }),
    checkIsMobile() {
      return checkIsMobileDevice()
    },

    checkIsTablet() {
      return checkIsTabletDevice()
    },
    async changeLive(sport) {
      await this.setLoadingLive({ status: true })
      await this.fetchLive({
        sport: sport.id,
        sport_id: sport._id,
        group: true,
      })
      this.getMarkets()
      await this.setLoadingLive({ status: false })
    },
    getTitle(item) {
      return _.find(item.detail, { lang: this.getLanguage }).text
    },
    checkIfEvents(events) {
      const filtered = _.filter(events, function (o) {
        return o != undefined && o.livescore.Scoreboard.Status == 2
      })
      return filtered.length > 0
    },
    groupByDate(events) {
      const filtered = _.filter(events, function (o) {
        return o.livescore.Scoreboard.Status == 2
      })
      const refactored = _.groupBy(filtered, 'day')
      return refactored
    },
    increaseLimit() {
      this.limit = this.limit + this.offset
    },
    decreaseLimit() {
      this.limit = this.limit - this.offset
    },
    changeLiveMode(mode) {
      this.setLiveMode({ mode: mode })
    },
    getRandomInt(min, max) {
      min = Math.ceil(min)
      max = Math.floor(max)
      return Math.floor(Math.random() * (max - min + 1)) + min
    },
    async putCart(odd, event, sport, category, tournament) {
      if (parseFloat(odd.outcome_odd_value) > 0 && odd.active) {
        await this.addOddToCart({
          odd: odd,
          event: event,
          sport: sport,
          category: category,
          tournament: tournament,
        })
        this.$root.$emit('forceUpdateSingleMultiple')
        this.$root.$emit('forceUpdateIntegral')
        this.$root.$emit('forceUpdateSystem')
      }
    },
    async getDetailOfEventLive(eventSource, type, sport, tournament, status) {
      this.loading = true
      document.body.scrollIntoView({ behavior: 'smooth' })
      window.parent.postMessage(
        {
          type: 'scrollTop',
        },
        '*'
      )
      await this.fetchEventLiveDetail({
        source: eventSource,
        group: 0,
        sport: sport,
        tournament: tournament,
        status: status,
      })
      this.loading = false
      await this.changeLiveMode('detail')
    },
    getMatchCurrentTime(time) {
      if (time >= 0) {
        const minutes = Math.floor(time / 60)
        const seconds = time - minutes * 60
        if (seconds > 0) {
          if (seconds < 10) {
            return minutes + ':0' + seconds
          } else {
            return minutes + ':' + seconds
          }
        } else {
          return minutes
        }
      } else {
        return 0
      }
    },
    getResult(result, team) {
      if (team == 'home') {
        var point = _.find(result, { Position: '1' })
        return point ? +point.Value : 0
      } else if (team == 'away') {
        var point = _.find(result, { Position: '2' })
        return point ? +point.Value : 0
      } else {
        return 0
      }
    },
    getMatchCurrentPeriod(period) {
      let find = _.find(period, { lang: this.getLanguage })
      if (find) {
        return find.text
      } else {
        find = _.find(period, { lang: 'en' })
        if (find) {
          return find.text
        } else {
          return ''
        }
      }
    },
    getMarkets() {
      if (this.getPreviewLive.length > 0 && this.getPreviewLive[0].markets) {
        this.markets = []
        _.forEach(this.getPreviewLive[0].markets, market => {
          market.unique_id =
            market.specifiers != ''
              ? market.id.toString() + '#' + market.specifiers
              : market.id.toString()
          this.markets.push(market)
        })

        this.market_selected = this.markets[0].unique_id
        this.markets_size =
          _.size(this.getPreviewLive[0].markets) > 3
            ? 3
            : _.size(this.getPreviewLive[0].markets)
        this.markets_size2 =
          _.size(this.getPreviewLive[0].markets) > 3
            ? 3
            : _.size(this.getPreviewLive[0].markets)
      }
    },
    getCategories() {
      const check = []
      this.categories_filtered = []
      this.all_categories = []

      _.forEach(this.getPreviewLive, event => {
        if (!check.includes(event.category.id)) {
          this.all_categories.push(event.category)
          check.push(event.category.id)
        }
      })
    },
    isServing(data, mode) {
      const serveNumber = _.find(data.LivescoreExtraData, { Name: 'Turn' })
      if (serveNumber) {
        if (mode == 'home' && serveNumber.Value == '1') {
          return true
        } else if (mode == 'away' && serveNumber.Value == '2') {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },

    filterCategory(id) {
      const index = _.indexOf(this.categories_filtered, id)
      if (index >= 0) {
        this.categories_filtered.splice(index, 1)
      } else {
        this.categories_filtered.push(id)
      }
    },

    isFiltered(id) {
      if (this.categories_filtered.length > 0) {
        return this.categories_filtered.includes(id)
      } else {
        return true
      }
    },

    checkAllFilter() {
      if (this.categories_filtered.length == 0) {
        return
      } else {
        this.categories_filtered = []
      }
    },
  },

  async mounted() {
    await this.setLoadingLive({ status: true })
    await this.fetchLive({ group: true })
    if (this.getPreviewLive[0] != undefined) {
      this.getMarkets()
      this.getCategories()
    }

    await this.setLoadingLive({ status: false })
  },
}
</script>
<style>
.img-sport-light {
  filter: invert(1);
}

.img-sport-dark {
  filter: invert(0);
}

.filter-live-category {
  display: flex;
  padding-bottom: 5px !important;
  padding-top: 5px !important;
}

.img-flag-filter {
  width: 20px;
  margin-right: 5px !important;
}

.active-sport {
  background: var(--active-color) !important;
  color: var(--third-color) !important;
}

.show-others {
  background: #272727 !important;
  color: #fff !important;
  border-radius: 5px !important;
  padding: 5px 8px !important;
}
</style>
